import React from 'react';
import styled from 'styled-components';
import avatar from '../img/avatar.jpg';
import back from '../img/back_1.jpg';
import { NavLink } from 'react-router-dom';
import FacebookIcon from '@material-ui/icons/Facebook';
import LinkedinIcon from '@material-ui/icons/LinkedIn';
import GithubIcon from '@material-ui/icons/GitHub';
import EmailIcon from '@material-ui/icons/Email';
import GetAppIcon from '@material-ui/icons/GetApp';
import { Link } from 'react-router-dom';

const handleTop = () => {
  window.scrollTo(0, 0);
};

function Navigation() {
  return (
    <NavigationStyled>
      <div className="avatar">
        <div className="btn-container">
          <Link
            to={{ pathname: 'https://drive.google.com/uc?export=download&id=1LRAQVYMT_PUgunwzLyW47OA4brSzwS3j' }}
            target="_blank"
          >
            <div className="btn">
              <span>Download CV</span>
              <GetAppIcon className="ico" />
            </div>
          </Link>
        </div>
        <img src={avatar} alt="" />
        <h2>Pedro Gonçalves</h2>
        <p>Front-End Web Developer</p>
      </div>
      <ul className="nav-items">
        <li className="nav-item">
          <NavLink to="/" activeClassName="active-class" exact onClick={handleTop}>
            Home
          </NavLink>
        </li>
        <li className="nav-item">
          <NavLink to="/about" activeClassName="active-class" exact onClick={handleTop}>
            About
          </NavLink>
        </li>
        <li className="nav-item">
          <NavLink to="/resume" activeClassName="active-class" exact onClick={handleTop}>
            Resume
          </NavLink>
        </li>
        <li className="nav-item">
          <NavLink to="/projects" activeClassName="active-class" exact onClick={handleTop}>
            Projects
          </NavLink>
        </li>
        <li className="nav-item">
          <NavLink to="/certificates" activeClassName="active-class" exact onClick={handleTop}>
            Certificates
          </NavLink>
        </li>
        <li className="nav-item">
          <NavLink to="/contact" activeClassName="active-class" exact onClick={handleTop}>
            Contact
          </NavLink>
        </li>
      </ul>

      <footer className="footer">
        <p>Get in Touch</p>
        <div className="icons">
          <a href="mailto:pedrogroug@gmail.com" className="icon i-email" rel="me" title="mail:pedrogroug@gmail.com">
            <EmailIcon />
          </a>
          <a href="https://www.facebook.com/pedro.grou" target="_blank" rel="noreferrer" className="icon i-facebook">
            <FacebookIcon />
          </a>
          <a
            href="https://www.linkedin.com/in/pedro-gon%C3%A7alves-80461115a/"
            target="_blank"
            rel="noreferrer"
            className="icon i-linkedin"
          >
            <LinkedinIcon />
          </a>
          <a href="https://github.com/PedroGrou" target="_blank" rel="noreferrer" className="icon i-github">
            <GithubIcon />
          </a>
        </div>
      </footer>
    </NavigationStyled>
  );
}

const NavigationStyled = styled.div`
  * {
    transition: all 300ms cubic-bezier(0.4, 0, 0.2, 1);
  }
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  align-items: center;
  height: 100%;
  width: 100%;
  border-right: 1px solid var(--border-color);
  transition: all 0.3s ease-in-out;
  &::before {
    content: '';
    background-image: url(${back});
    background-repeat: no-repeat;
    opacity: 0.4;
    background-size: cover;
    position: absolute;
    top: 0px;
    right: 0px;
    bottom: 0px;
    left: 0px;
    opacity: 0.2;
    z-index: -10;
  }
  .avatar {
    width: 100%;
    border-bottom: 1px solid var(--border-color);
    text-align: center;
    padding: 1rem 0;
    z-index: 10;
    transition: all 0.3s ease-in-out;

    .btn-container {
      position: absolute;
      top: 5%;
      left: 20%;
    }

    .btn {
      font-size: 1.1em;
      padding: 5px 2px;
      background-color: var(--border-color);
      color: #fff;
      border-radius: 50px;
      margin: auto;
      border: 1px solid var(--border-color);
    }
    .btn span {
      color: var(--font-light-color);
      font-size: 0;
      padding: 5px 15px;
    }

    .btn:hover {
      padding: 10px 30px 10px 5px;
      border: 1px solid var(--border-color);
    }
    .btn:hover span {
      font-size: 1rem;
      padding: 5px 10px;
    }
    .btn:hover .ico {
      margin-left: 0px;
      transform: rotate(360deg);
    }
    .btn:hover .span {
      visibility: visible;
    }
    .ico {
      transition: all 0.5s;
      background-color: var(--font-light-color);
      color: var(--border-color);
      width: 23px;
      height: 23px;
      padding: 1px;
      border-radius: 46px;
      position: absolute;
      margin-left: -27px;
      font-size: 1rem;
    }
    .ico::before {
      transition: all 300ms cubic-bezier(0.4, 0, 0.2, 1);
      content: '\f2c3' !important;
      font-family: Ionicons;
      margin-left: -5px;
    }
    .btn:hover .ico::before {
      transition: all 300ms cubic-bezier(0.4, 0, 0.2, 1);
      content: '\f10b' !important;
      font-family: Ionicons;
      margin-left: -5px;
    }

    h2 {
      font-size: 1.5rem;
    }
    p {
      font-size: 0.8rem;
    }
    img {
      width: 70%;
      border-radius: 50%;
      border: 8px solid var(--border-color);
      opacity: 1;
      transition: all 0.3s ease-in-out;
    }
  }
  .nav-items {
    width: 100%;
    text-align: center;

    .nav-item {
      display: block;
      a {
        display: block;
        padding: 0.2rem;
        position: relative;
        z-index: 8;
        text-transform: uppercase;
        transition: all 0.4s ease-in-out;
        font-weight: 600;
        letter-spacing: 1px;
        &:hover {
          cursor: pointer;
          color: var(--primary-color);
        }
        &::before {
          content: '';
          position: absolute;
          transition: all 0.4s cubic-bezier(1, -0.1, 0.25, 0.95);
          bottom: 0;
          left: 0;
          width: 0;
          height: 50%;
          background-color: var(--primary-color);
          z-index: 3;
          opacity: 0.21;
        }
      }

      a:hover::before {
        width: 100%;
        height: 100%;
      }
    }
    .active-class {
      background-color: var(--primary-color);
    }
  }
  footer {
    text-align: center;
    width: 100%;
    border-top: 1px solid var(--border-color);
    p {
      padding-top: 1rem;
      font-size: 0.8rem;
      display: block;
    }
    .icons {
      display: flex;
      justify-content: center;

      .icon {
        display: flex;
        align-items: center;
        justify-content: center;

        transition: all 0.4s ease-in-out;
        cursor: pointer;
        padding: 0.5rem;
      }
      .i-email {
        &:hover {
          color: var(--white-color);
        }
      }
      .i-facebook {
        &:hover {
          color: #3b5998;
        }
      }

      .i-linkedin {
        &:hover {
          color: #0e76a8;
        }
      }
      .i-github {
        &:hover {
          color: #5f4687;
        }
      }
    }
  }
`;

export default Navigation;
